export class AbstractTodoTask {

  id?: number;
  version: number;
  sequenceNum: number;
  subtype: EntityType;
  duedate: Date;
  title: string;
  description: string;
  reminder: boolean;
  completed: boolean;

  enableUserToChangeTODOStatus: boolean;

  taskLaneId: number;
  assignedById: number;
  assignedToId: number;
  vendorId: number;
  customerId: number;
  contractId: number;
  projectId: number;
  projectEstimateId: number;

  taskTodoComments: TaskTodoComment[];

  // Transient field
  taskLaneName: string;
  assignedToName: string;
  assignedByName: string;
}

export class TaskTodoComment {
  id?: number;
  version?: number;

  comment: string;
  todoTask: AbstractTodoTask;

  // For transient field
  userFullName: string;
}

enum EntityType {
  VENDOR, CUSTOMER, CONTRACT, PROJECT, PROJECT_ESTIMATE
}
